import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49327a60")

_pushScopeId("data-v-49327a60")
const _hoisted_1 = { class: "r-grid container" }
const _hoisted_2 = {
  key: 0,
  class: "r-grid message"
}
const _hoisted_3 = { class: "expanded-item" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "button-group"
}
const _hoisted_6 = {
  key: 2,
  class: "button-group"
}
const _hoisted_7 = {
  key: 3,
  class: "button-group"
}
const _hoisted_8 = {
  key: 4,
  class: "button-group"
}
const _hoisted_9 = {
  key: 6,
  class: "button-group"
}
const _hoisted_10 = {
  key: 8,
  class: "button-group"
}
const _hoisted_11 = {
  key: 9,
  class: "button-group"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccordionTitle = _resolveComponent("AccordionTitle")!
  const _component_arrowSVG = _resolveComponent("arrowSVG")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_AccordionTitle, {
        title: _ctx.title,
        toggle: _ctx.listToggle,
        "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listToggle = $event)),
        onUpdateToggle: _cache[2] || (_cache[2] = ($event: any) => (_ctx.listToggle = $event))
      }, null, 8, ["title", "toggle"])
    ]),
    (_ctx.userLeaveList && _ctx.userLeaveList.length === 0)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_2, " No items to display. ", 512)), [
          [_vShow, _ctx.listToggle]
        ])
      : _createCommentVNode("", true),
    _createVNode("ol", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userLeaveList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock("li", {
          class: "r-grid grid-container",
          key: index,
          "aria-expanded": item.boolean
        }, [
          _createVNode("div", {
            onClick: ($event: any) => (item.boolean = !item.boolean),
            class: ["status-color", item.status]
          }, null, 10, ["onClick"]),
          _createVNode("div", {
            onClick: ($event: any) => (item.boolean = !item.boolean),
            class: "date"
          }, _toDisplayString(_ctx.formatDate(item.date)), 9, ["onClick"]),
          _createVNode("div", {
            onClick: ($event: any) => (item.boolean = !item.boolean),
            class: "status",
            innerHTML: _ctx.parseStatusTitle(item.status)
          }, null, 8, ["onClick", "innerHTML"]),
          _createVNode("button", {
            onClick: ($event: any) => (item.boolean = !item.boolean),
            class: [{ 'active': item.boolean }, "button-toggle"]
          }, [
            _createVNode(_component_arrowSVG)
          ], 10, ["onClick"]),
          _withDirectives(_createVNode("div", _hoisted_3, [
            (_ctx.userInfoData && _ctx.userInfoData.leaves_value_type === 'Hours')
              ? (_openBlock(), _createBlock("p", _hoisted_4, " Leave Duration: " + _toDisplayString(_ctx.parseDurationType(item.duration_type, item.duration_hours)), 1))
              : _createCommentVNode("", true),
            _createVNode("p", null, "Leave Type: " + _toDisplayString(item.type_display_title), 1),
            (_ctx.$route.name == 'Home'
        && (item.status == 'approved'
        || item.status == 'pending-approval'))
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    text: "Withdraw",
                    onClick: ($event: any) => (_ctx.withdrawRequest(item.uuid, $event)),
                    async: true
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    text: "View Comment",
                    to: `/leave-item/${item.uuid}`
                  }, null, 8, ["to"])
                ]))
              : ((_ctx.$route.name == 'Home') && item.status == 'declined')
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_Button, {
                      text: "Delete",
                      onClick: ($event: any) => (_ctx.deleteDeclined(item.uuid, $event)),
                      async: true
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      text: "Edit Details",
                      to: `/leave-item/${item.uuid}`
                    }, null, 8, ["to"])
                  ]))
                : ((_ctx.$route.name == 'View/Edit User')
        && item.status == 'declined')
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode(_component_Button, {
                        text: "Delete",
                        onClick: ($event: any) => (_ctx.deleteDeclined(item.uuid, $event)),
                        async: true,
                        disabled: _ctx.isHRAdminReadOnly
                      }, null, 8, ["onClick", "disabled"]),
                      _createVNode(_component_Button, {
                        text: "View Details",
                        onClick: ($event: any) => (_ctx.hrViewLeave(item.uuid, $event)),
                        async: true,
                        disabled: _ctx.isHRAdminReadOnly
                      }, null, 8, ["onClick", "disabled"])
                    ]))
                  : (_ctx.$route.name == 'Home'
        && item.status == 'conflict')
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _createVNode(_component_Button, {
                          text: "Delete",
                          onClick: ($event: any) => (_ctx.deleteDeclined(item.uuid, $event)),
                          async: true
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          text: "View Details",
                          to: `/leave-item/${item.uuid}`
                        }, null, 8, ["to"])
                      ]))
                    : (_ctx.$route.name == 'Home'
        && item.status == 'pending-withdrawal')
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 5,
                          text: "View Details",
                          to: `/leave-item/${item.uuid}`
                        }, null, 8, ["to"]))
                      : ((_ctx.$route.name == 'Manage Single Employee')
        && item.status == 'approved')
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode(_component_Button, {
                              text: "Decline",
                              onClick: ($event: any) => (_ctx.declineRequest([item.uuid], $event)),
                              async: true
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_Button, {
                              text: "View Comment",
                              to: `/manage-employees/${_ctx.$route.params.uin}/leave-item/${item.uuid}`
                            }, null, 8, ["to"])
                          ]))
                        : (_ctx.$route.name == 'Manage Single Employee')
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 7,
                              text: "View Comment",
                              to: `/manage-employees/${_ctx.$route.params.uin}/leave-item/${item.uuid}`
                            }, null, 8, ["to"]))
                          : (_ctx.$route.name == 'View/Edit User'
        && item.status == 'conflict')
                            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                _createVNode(_component_Button, {
                                  text: "Delete",
                                  onClick: ($event: any) => (_ctx.deleteDeclined(item.uuid, $event)),
                                  async: true,
                                  disabled: _ctx.isHRAdminReadOnly
                                }, null, 8, ["onClick", "disabled"]),
                                _createVNode(_component_Button, {
                                  text: "View Comment",
                                  onClick: ($event: any) => (_ctx.hrViewLeave(item.uuid))
                                }, null, 8, ["onClick"])
                              ]))
                            : (_ctx.$route.name == 'View/Edit User'
        && item.status == 'approved')
                              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                  _createVNode(_component_Button, {
                                    text: "Decline",
                                    onClick: ($event: any) => (_ctx.declineRequest([item.uuid], $event)),
                                    async: true,
                                    disabled: _ctx.isHRAdminReadOnly
                                  }, null, 8, ["onClick", "disabled"]),
                                  _createVNode(_component_Button, {
                                    text: "View Comment",
                                    onClick: ($event: any) => (_ctx.hrViewLeave(item.uuid))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, item.boolean]
          ])
        ], 8, ["aria-expanded"])), [
          [_vShow, _ctx.listToggle]
        ])
      }), 128))
    ])
  ], 64))
})